module.exports = new __parcel__URL__("apple-touch-icon.abc4aca2.png").toString();